import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.SUBSCRIPTIONS_DISABLED;

/**
 * Checks if the subscriptions module is disabled for the company (small ICP setup).
 *
 * @returns {boolean} True when the `subscriptions_disabled` company feature is enabled.
 *
 * @example
 * const isSubscriptionsDisabled = useIsSubscriptionsDisabled();
 */
export const useIsSubscriptionsDisabled = () => {
  return useCompanyFeatureAvailable(featureName);
};
